module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "6546.e0da30d3.jpg";